import focusSource from 'ally.js/src/style/focus-source';

focusSource();



// WEBPACK FOOTER //
// ./project/client/src/site__vegkit/utilities/a11y__focus.js